import EventsList from './events-list'

export default EventsList
